import { Outlet } from "react-router-dom";
import Navbar from "../Navbar/Navbar";
import React from "react";
import ProfileNav from "../ProfileNav/ProfileNav";
import { useAutoLogout } from "../../hooks/useAutoLogout";

export default function Layout() {
  // Initialize auto logout functionality
  useAutoLogout();

  return (
    <div className="lg:flex min-h-screen bg-gray-50">
      <Navbar />
      <main className="flex-1 ml-0 lg:ml-[270px] p-8 lg:p-4 transition-all duration-300 mt-10 flex-wrap">
        <ProfileNav />
        <Outlet />
      </main>
    </div>
  );
}